import React, { createContext, useState } from 'react'
import { API, defaultError, config, closeSession } from "../config";
import axios from "axios";
import useSWR from 'swr';
import Compressor from 'compressorjs';

const MyNewsContext = createContext();

const MyNewsProvider = ({ children }) => {
    const [error, setError] = useState({ "error": false, "message": "" });
    const [newN, setNewN] = useState({ "newTitle": "", "newDescription": "" });
    const [news, setNews] = useState([]);
    const [sorters, setSorters] = useState({ "sorter": "date", "order": "desc" });
    const [page, setPage] = useState(0);
    const [pageAdmin, setPageAdmin] = useState(0);
    const [maxPage, setMaxPage] = useState(0);
    const [image, setImage] = useState({});
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetcher = () => axios.get(`${API}/news/getallnews/${sorters.sorter}/${sorters.order}/${page}`).then(async res => {
        setFiles(res.data.files);
        setMaxPage(res.data.maxPage);
        return res.data.response
    });


    function useNews() {
        const { data, error } = useSWR(`${API}/news/getallnews/${sorters.sorter}/${sorters.order}/${page}`, fetcher);
        return {
            news: data,
            isLoading: !error && !data,
            isError: error
        }
    }

    const getNewsAdmin = async () => {
        setError({ "error": false, "message": "" });
        setLoading(true);
        await axios.get(`${API}/news/news/${pageAdmin}`, config).then(res => {
            if (res.data.error) {
                if (res.data.status == "400-1") {
                    closeSession();
                }
                setLoading(false);
                //seterror and put false after 3 seconds
                setError({ "error": true, "message": res.data.response });
                return;
            }
            setFiles(res.data.files);
            setMaxPage(res.data.maxPage);
            setNews(res.data.response);
        }).catch(err => {
            setError(defaultError);
        });
        setLoading(false);
    }

    const getFile = async (filePath) => {
        setLoading(true);
        await axios.get(`${API}/news/getfile/${filePath}`).then(res => {
            setError({ "error": false, "message": "" });
            if (res.data.error) {
                setLoading(false);
                //seterror and put false after 3 seconds
                setError({ "error": true, "message": res.data.response });
                setTimeout(() => {
                    setError({ "error": false, "message": "" });
                }, 3000);
                return;
            }
            const binaryString = window.atob(res.data.response);
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            const url = window.URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));


            const link = document.createElement('a');
            link.href = url;
            //link.setAttribute('download', filePath);
            link.setAttribute('download', 'Novedad ' + filePath.substring(filePath.length - 14));
            document.body.appendChild(link);
            link.click();
            setLoading(false);
        }).catch(err => {
            setLoading(false);
            setError({ "error": true, "message": "Ha ocurrido un error al descargar el archivo" });
            setTimeout(() => {
                setError({ "error": false, "message": "" });
            }, 3000);
        });
    }

    const addNew = async (data) => {
        setLoading(true);
        return new Promise((resolve, reject) => {
            new Compressor(new File([data.newFile[0]], "newFile.jpg", { type: "image/jpeg" }), {
                quality: 0.5,
                async success(result) {
                    var formData = new FormData();
                    formData.append("newFile", new File([result], result.name, { type: result.type }));
                    formData.append("newDocument", data.newDocument.length > 0 ? data.newDocument[0] : new File([], "empty"));
                    formData.append("newTitle", data.newTitle);
                    formData.append("newDescription", data.newDescription);

                    config.headers["Content-Type"] = "multipart/form-data";
                    try {
                        const res = await axios.post(`${API}/news/addnew`, formData, config)
                        if (res.data.status == "400-1") {
                            closeSession();
                        }
                        if (!res.data.error) {
                            getNewsAdmin();
                        }
                        setLoading(false);
                        resolve(res.data);
                    } catch (err) {
                        setLoading(false);
                        resolve(defaultError);
                    }
                },
                async error(err) {
                    setLoading(false);
                    resolve(defaultError);
                },
            });
        });
    }

    const updateNew = async (data, newId) => {
        setLoading(true);
        return new Promise(async (resolve, reject) => {

            var formData = new FormData();
            formData.append("newDocument", data.newDocument.length > 0 ? data.newDocument[0] : new File([], "empty"));
            formData.append("newTitle", data.newTitle);
            formData.append("newDescription", data.newDescription);
            config.headers["Content-Type"] = "multipart/form-data";

            if (data.newFile.length > 0) {
                new Compressor(new File([data.newFile[0]], "newFile.jpg", { type: "image/jpeg" }), {
                    quality: 0.5,
                    async success(result) {
                        formData.append("newFile", new File([result], result.name, { type: result.type }));
                        const res = await putUpdateNew(formData, newId);
                        resolve(res.data);
                    },
                    error(err) {
                        setLoading(false);
                        resolve(defaultError);
                    },
                });
            } else{
                formData.append("newFile", new File([], "empty"));
                const res = await putUpdateNew(formData, newId);
                resolve(res.data);
            }
            
        });
    }

    const putUpdateNew = async (formData, newId) => {
        try {
            console.log("3")
            const res = await axios.put(`${API}/news/updatenew/${newId}`, formData, config)
            if (res.data.status == "400-1") {
                closeSession();
            }
            if (!res.data.error) {
                getNewsAdmin();
            }
            setLoading(false);
            return(res);
        } catch (err) {
            console.log("4")
            setLoading(false);
            return(defaultError);
        }
    }
    
    const changeNewVisibility = async (newId) => {
        try {
            const res = await axios.put(`${API}/news/changenewvisibility/${newId}`, {}, config)
            if (res.data.status == "400-1") {
                closeSession();
            }
            if (!res.data.error) {
                getNewsAdmin();
            }
            return res.data;
        } catch (err) {
            return defaultError;
        }
    }

    const deleteNew = async (newId) => {
        setLoading(true);
        try {
            const res = await axios.delete(`${API}/news/deletenew/${newId}`, config)
            if (res.data.status == "400-1") {
                closeSession();
            }
            if (!res.data.error) {
                getNewsAdmin();
            }
            setLoading(false);
            return res.data;
        } catch (err) {
            setLoading(false);
            return defaultError;
        }
    }

    return (
        <MyNewsContext.Provider value={{
            error,
            newN,
            setNewN,
            sorters,
            setSorters,
            maxPage,
            useNews,
            setPage,
            image,
            setImage,
            files,
            setFiles,
            loading,
            setLoading,
            getNewsAdmin,
            news,
            pageAdmin,
            setPageAdmin,
            setError,
            addNew,
            updateNew,
            changeNewVisibility,
            deleteNew,
            getFile
        }}>
            {children}
        </MyNewsContext.Provider>
    );
}

export { MyNewsProvider };
export default MyNewsContext;